import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "!absolute !transform-none !left-auto !right-2 !top-2 !bg-transparent !border-0 !text-muted-foreground hover:!text-foreground",
          error:
            "group toast group-[.toaster]:border-red-200 group-[.toaster]:bg-red-50 group-[.toaster]:text-red-600 [&_button[data-button=true][data-action=true]]:!bg-red-200 [&_button[data-button=true][data-action=true]]:!text-red-800 [&_button[data-button=true][data-action=true]:hover]:!bg-red-300 [&_svg]:text-red-700 [&_div[data-description]]:!text-red-500",
          success:
            "group toast group-[.toaster]:border-green-200 group-[.toaster]:bg-green-50 group-[.toaster]:text-green-700 [&_button[data-button=true][data-action=true]]:!bg-green-200 [&_button[data-button=true][data-action=true]]:!text-green-800 [&_button[data-button=true][data-action=true]:hover]:!bg-green-300 [&_svg]:text-green-700 [&_div[data-description]]:!text-green-600",
          warning:
            "group toast group-[.toaster]:border-amber-200 group-[.toaster]:bg-amber-50 group-[.toaster]:text-amber-700 [&_button[data-button=true][data-action=true]]:!bg-amber-200 [&_button[data-button=true][data-action=true]]:!text-amber-800 [&_button[data-button=true][data-action=true]:hover]:!bg-amber-300 [&_svg]:text-amber-700 [&_div[data-description]]:!text-amber-600 [&_div[data-title]]:!text-amber-700",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
